<template>
  <div class="wrapper">
    <section class="schoolProgramHead">
      <div class="container">
        <div class="schoolProgramHeadInside">
          <div class="row">
            <div class="col-md-8">
              <h2>Juniors School</h2>
            </div>
            <div class="col-md-4 grade-enroll" v-if="!isFetching">
              <div v-if="courseList.length > 0" class="purple-btn pointer" @click="goToCategory()">Enroll</div>
              <div class="purple-btn pointer" v-else-if="courseList.length == 0">Coming soon</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="schoolProgramWrap section-space">
      <div class="container">
        <div class="row">
          <div class="col-md-3" :class="{ 'active-class': !isFooterVisible }">
            <div class="gradesWrap" :class="{ scrolled: isScrolled, fixed: isFixed }">
              <a href="#grade-6" class="gradesCell"> Grade 6 </a>
              <a href="#grade-7" class="gradesCell"> Grade 7 </a>
              <a href="#grade-8" class="gradesCell"> Grade 8 </a>
            </div>
          </div>
          <div class="col-md-9 programDescCol">
            <div class="row" id="grade-6">
              <div class="col-lg-6 order-lg-2">
                <div class="programImgWrap">
                  <img src="/assets/images/os-images/school-pro-image.png" width="499" height="293" alt="" />
                </div>
              </div>
              <div class="col-lg-6 order-lg-1">
                <div class="programDescWrap">
                  <h4>Grade 6</h4>
                  <span>Age Group: <small>11–14 years </small> </span>
                  <h4>Program Description</h4>
                  <p>Designed to build a strong academic foundation while fostering critical thinking, creativity, and
                    personal growth. The program bridges primary and higher education through interactive and engaging
                    learning experiences.</p>
                  <h4>Program Features</h4>
                  <ul>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                  </ul>
                  <h4>Learning Formats</h4>
                  <p>Live classes and recorded sessions for flexible learning opportunities.</p>
                  <h4>Teaching Methodology</h4>
                  <p>Inquiry-driven and differentiated, focusing on critical thinking, creativity, and skill development
                    to cater to diverse learning needs</p>
                </div>
              </div>
            </div>
            <div class="row" id="grade-7">
              <div class="col-lg-6 order-lg-2">
                <div class="programImgWrap">
                  <img src="/assets/images/os-images/school-pro-image.png" width="499" height="293" alt="" />
                </div>
              </div>
              <div class="col-lg-6 order-lg-1">
                <div class="programDescWrap">
                  <h4>Grade 7</h4>
                  <span>Age Group: <small>11–14 years </small> </span>
                  <h4>Program Description</h4>
                  <p>Designed to build a strong academic foundation while fostering critical thinking, creativity, and
                    personal growth. The program bridges primary and higher education through interactive and engaging
                    learning experiences.</p>
                  <h4>Program Features</h4>
                  <ul>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                  </ul>
                  <h4>Learning Formats</h4>
                  <p>Live classes and recorded sessions for flexible learning opportunities.</p>
                  <h4>Teaching Methodology</h4>
                  <p>Inquiry-driven and differentiated, focusing on critical thinking, creativity, and skill development
                    to cater to diverse learning needs</p>
                </div>
              </div>
            </div>
            <div class="row" id="grade-8">
              <div class="col-lg-6 order-lg-2">
                <div class="programImgWrap">
                  <img src="/assets/images/os-images/school-pro-image.png" width="499" height="293" alt="" />
                </div>
              </div>
              <div class="col-lg-6 order-lg-1">
                <div class="programDescWrap">
                  <h4>Grade 8</h4>
                  <span>Age Group: <small>11–14 years </small> </span>
                  <h4>Program Description</h4>
                  <p>Designed to build a strong academic foundation while fostering critical thinking, creativity, and
                    personal growth. The program bridges primary and higher education through interactive and engaging
                    learning experiences.</p>
                  <h4>Program Features</h4>
                  <ul>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                  </ul>
                  <h4>Learning Formats</h4>
                  <p>Live classes and recorded sessions for flexible learning opportunities.</p>
                  <h4>Teaching Methodology</h4>
                  <p>Inquiry-driven and differentiated, focusing on critical thinking, creativity, and skill development
                    to cater to diverse learning needs</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { classCourses as classCoursesStoreKeys } from "../store/keys";
export default {
  data() {
    return {
      isFetching: false,
      isFooterVisible: false,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getClassCourses();
    window.addEventListener("scroll", this.checkFooterInView);
    this.checkFooterInView();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.checkFooterInView);
  },
  computed: {
    ...mapGetters(classCoursesStoreKeys.namespace, classCoursesStoreKeys.getters),
  },
  methods: {
    ...mapActions(classCoursesStoreKeys.namespace, classCoursesStoreKeys.actions),
    getClassCourses() {
      this.isFetching = true;
      this.get_ClassCourses({
        data: {
          ProgramCategoryId: this.$decryptedRouteParams.id,
          PageNumber: 1,
          PageSize: 10,
        },
        config: {
          loader: {
            show: true,
          },
        },
      })
        .then((response) => {
          this.isFetching = false;
        })
        .catch((ex) => {
          this.isFetching = false;
          // this.$alertError(ex.message);
          console.log(ex)
        });
    },
    goToCategory() {
      this.$router.push({
        name: this.$route.params.routeName,
        params: { categoryId: this.$route.params.id },
      });
    },
    checkFooterInView() {
      const footer = document.querySelector(".site-footer");
      if (footer) {
        const rect = footer.getBoundingClientRect();
        this.isFooterVisible = rect.top >= window.innerHeight - 150;
      }
    },
  },
};
</script>
